import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import Pagination from '../../../components/pagination';
import TextTabs from '../../../components/modules/textTabs/simple';

import Ticket from './ticket';
import TicketService from '../../../services/ticket.service';
import Search from '../../../components/searchField';
import AddNew from './ticket/addNew';


const Tickets = ({
  t,
  data,
  count,
  addNew,
  isEmpty,
  goToPage,
  criteria,
  loadTicket,
  addNewTicket,
  backgroundCover,
  backgroundColor,
  enableCoverColor,
  addNewTicketEmpty,
  callbackToSetSearch,
  moduleTitle,
  ...props
}) => (
  <React.Fragment>
    <PageTitle
      title={moduleTitle}
      backgroundPage={backgroundColor}
      backgroundCover={backgroundCover}
      enableCoverColor={enableCoverColor}
    />
    <section className="Blog2 boxs dpreview tickets">
      <div className="container">
        <div className="Blog2inner boxs pdlr">
          <Navigation />
          <div className="middleKB">
            {isEmpty.status !== 1 ?
              <div className="middleinner boxs">
                <Search
                  placeholder={t('Search tickets')}
                  callbackToSetSearch={callbackToSetSearch}
                />
                <div className="boxs dticketD">
                  <div className="after6" />
                  <div className="kbleftw">
                    <div className="previewlinks ticketlinks boxs">
                      <div className="plinks_inner boxs">
                        <h3>{t('My tickets')}</h3>
                        <TextTabs
                          addNew={addNew}
                          cssClass="surveytabs boxs portaltabs"
                          data={data}
                          service={TicketService}
                          addPlaceholder={t('Add new ticket')}
                          {...props}
                        />
                        <div>
                          <Pagination
                            goToPage={goToPage}
                            count={count}
                            pageSize={criteria.limit}
                            page={criteria.page}
                            backgroundColor={backgroundColor}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="kbrightw">
                    <div className="dpreviewscrollto boxs">
                      <div className="addnewfedbck boxs">
                        <div className="boxs addfdbckcmntD addfdbckticket">
                          <Switch>
                            <Route
                              exact
                              path="/ticket/new"
                              render={prop => (<AddNew
                                goToPage={goToPage}
                                {...prop}
                              />)}
                            />
                            <Route
                              exact
                              path="/ticket/:id"
                              render={prop => (<Ticket
                                backgroundColor={backgroundColor}
                                setUpdated={props.setUpdated}
                                {...prop}
                              />)}
                            />
                            <Route
                              render={prop => (
                                <div className="tictabs tictabs1">
                                  <div className="choseprty boxs">
                                    <div className="lefttD">
                                      <div className="boxs">
                                        <h6>
                                          {isEmpty.status !== 2 ?
                                            t('Please select ticket to see') :
                                            t('Your search does not match any item')
                                          }
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>)}
                            />
                            <Redirect from="*" to="/ticket" />
                          </Switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> :
              <div className="middleinner boxs">
                <Switch>
                  <Route
                    exact
                    path="/ticket"
                    render={prop => (
                      <div className="notickets boxs">
                        <h3>{t('There are no tickets')}</h3>
                        <a href="#" onClick={e => addNewTicketEmpty(e)}>{t('Add new')}</a>
                      </div>)}
                  />
                  <Redirect from="*" to="/ticket" />
                </Switch>
              </div>}
          </div>
        </div>
      </div>
    </section>
  </React.Fragment>
);

Tickets.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired,
  criteria: PropTypes.object.isRequired,
  activeTicket: PropTypes.object,
  isEmpty: PropTypes.object.isRequired,
  addNewTicketEmpty: PropTypes.func.isRequired,
};

export default Tickets;



// WEBPACK FOOTER //
// ./src/views/modules/ticket/Tickets.jsx